import "./pie-chart-component.scss";
import React from "react";
import { PieChart } from "react-minimal-pie-chart";

function PieChartComponent(props) {
  return (
    <div className="user_comp_nutr">
      <div className="piechart">
        <PieChart
          data={[
            { title: "Active", value: props?.usedSeats || 0, color: "#FCBC05" },
            { title: "Remaining", value: props?.remainingSeats || 0, color: "#6362E7" },
          ]}
        />
        <div className="chart_inside" style={{ cursor: "pointer" }}>
          <span className="used-seats">
            {props?.usedSeats || 0} seats
          </span>
          <span className="available-seats">
            {props?.remainingSeats || 0} Available seats
          </span>
        </div>
      </div>
    </div>
  );
}

export default PieChartComponent;
